import moment from "moment";
import { convertDateToUTC, generateHoursList } from '../../utils/utils';
import { OLD_BOOKINGS_END_TIME } from '../../config'

export const isFetchingRentalPrice = (state) => {
    return state.bookings.request_types.fetching_price;
}

export const getRentalPrice = (state) => {
    return state.bookings.rental_price
}

export const getBookingsForProduct = (state, productId, rentals) => {
    const bookings = rentals ? state.bookings.rental_bookings : state.bookings.bookings;
    return bookings[productId] ? bookings[productId] : [];
}

export const isBookingFetching = (state) => {
    return state.bookings.request_types.fetching;
}

export const isBookingDeleting = (state) => {
    if (state.bookings.request_types.deleting_booking) {
        return state.bookings.request_types.deleting_booking
    }
    return null;
}

export const isBookingSending = (state) => {
    return state.bookings.request_types.sending;
}

export const userBookings = (bookings, userId) => {
    if (!bookings) {
        return [];
    }
    return bookings.filter(booking => (booking.user_guid === userId));
}

export const getBookingStatsForProduct = (state, productId, rentals) => {
    const bookings = getBookingsForProduct(state, productId, rentals);
    if (bookings.length === 0) return null;
    let bookings_before_bug_fix = [];
    let bookings_after_bug_fix = [];
    bookings.forEach(booking => {
        if (booking.created_at < OLD_BOOKINGS_END_TIME) {  // to be deleted after all bookings ends at => OLD_BOOKINGS_END_TIME and only getEmptyDaysBookingStatus will remain and all bookings will be in the same array
            bookings_before_bug_fix.push(booking);
        } else {
            bookings_after_bug_fix.push(booking);
        }
    })

    const bookings_old = getDaysBookingStatus(bookings_before_bug_fix);
    const bookings_new = getBookingStatsPerDay(bookings_after_bug_fix);

    const merged_booking = mergeBookings(bookings_old, bookings_new);

    let day_bookings_statistics = {};
    Object.keys(merged_booking).forEach(day => {
        const day_stats = checkIfDayHasEmptyIntervals(day, merged_booking[day]['bookings']);
        day_bookings_statistics[day] = day_stats;
    })
    return day_bookings_statistics;
}

const mergeBookings = (bookings_old, bookings_new) => {  // to be deleted after all bookings ends at => OLD_BOOKINGS_END_TIME
    const merged_bookings = { ...bookings_old, ...bookings_new };
    const booking_days = Object.keys(merged_bookings);
    let bookings = {};
    booking_days.forEach(day => {
        const bookings_from_old = bookings_old[day] ? bookings_old[day]['bookings'] : []
        const bookings_from_new = bookings_new[day] ? bookings_new[day]['bookings'] : []
        bookings[day] = { bookings: [...bookings_from_old, ...bookings_from_new] }
    })
    return bookings;
}

const getBookingStatsPerDay = (bookings) => {
    let day_bookings = {};

    bookings.forEach(booking => {
        const start = moment.utc(booking.start_time).format("YYYY-MM-DD");
        const end = moment.utc(booking.end_time).format("YYYY-MM-DD");
        if (!day_bookings[start]) {
            day_bookings[start] = { bookings: [] };
        }
        if (!day_bookings[end]) {
            day_bookings[end] = { bookings: [] };
        }

        const day_booking = {
            start: booking.start_time,
            end: booking.end_time
        }

        day_bookings[start].bookings.push(day_booking);
        day_bookings[end].bookings.push(day_booking);
    })
    return day_bookings;
}

const checkIfDayHasEmptyIntervals = (day, day_bookings) => {
    const day_hours = generateHoursList(day, true);
    let is_full_day = true;
    day_hours.forEach(hour => {
        const parsed_hour = new Date(Date.UTC(hour.year(), hour.month(), hour.date(), hour.hour(), hour.minute(), 0, 0)).getTime();
        const overlap_checks = searchForDayTimeOverlapping(parsed_hour, day_bookings);
        if (!overlap_checks.overlaps) {
            is_full_day = false;
        }
    })
    return {
        is_full_day
    }
}

const searchForDayTimeOverlapping = (hour, bookings) => {
    let overlaps = false;
    bookings.forEach(booking => {
        if (booking.start <= hour && hour <= booking.end) {
            overlaps = true;
        }
    })

    return { overlaps };
}


const getDaysBookingStatus = (bookings) => {   // to be deleted after all bookings ends at => OLD_BOOKINGS_END_TIME
    let total_booking_starts_and_end = {};
    let bookings_start_days = {};
    let bookings_end_days = {};

    bookings.forEach(booking => {
        const start = moment.utc(booking.start_time).format("YYYY-MM-DD");
        const end = moment.utc(booking.end_time).format("YYYY-MM-DD");
        total_booking_starts_and_end[start] = {};
        total_booking_starts_and_end[end] = {};

        let parsed_end_time = null;
        const date_end_time = convertDateToUTC(new Date(booking.end_time))
        const end_time = moment(date_end_time);

        if (end_time.hour() === 0 && end_time.minute() === 0) {
            const next_day = end_time.clone().add(1, 'day');
            const parsed_hour = new Date(Date.UTC(next_day.year(), next_day.month(), next_day.date(), next_day.hour(), next_day.minute(), 0, 0)).getTime();
            parsed_end_time = parsed_hour;
        }

        if (bookings_start_days[start]) {
            bookings_start_days[start].bookings.push({
                start: booking.start_time,
                end: parsed_end_time ? parsed_end_time : booking.end_time
            });
        } else {
            bookings_start_days[start] = {
                bookings: [{
                    start: booking.start_time,
                    end: parsed_end_time ? parsed_end_time : booking.end_time
                }]
            }
        }

        if (bookings_end_days[end]) {
            bookings_end_days[end].bookings.push({
                start: booking.start_time,
                end: parsed_end_time ? parsed_end_time : booking.end_time
            });
        } else {
            bookings_end_days[end] = {
                bookings: [{
                    start: booking.start_time,
                    end: parsed_end_time ? parsed_end_time : booking.end_time
                }]
            }
        }
    })

    Object.keys(total_booking_starts_and_end).forEach(day => {
        if (bookings_start_days[day] && bookings_end_days[day]) {
            total_booking_starts_and_end[day] = {
                bookings: [...bookings_start_days[day]['bookings'], ...bookings_end_days[day]['bookings']],
            }
        } else {
            if (bookings_start_days[day]) {
                total_booking_starts_and_end[day] = bookings_start_days[day];
            }

            if (bookings_end_days[day]) {
                total_booking_starts_and_end[day] = bookings_end_days[day];
            }
        }
    })
    return total_booking_starts_and_end;
}


export const getSelectedIntervals = (state, productId, myGuid, rentals) => {
    const bookings = getBookingsForProduct(state, productId, rentals);
    const booking_stats = getBookingStatsForProduct(state, productId, rentals);

    let users = {};
    let modifiers = { "not_full": [] };
    let modifiersStyles = {}

    if (bookings.length === 0) return {
        users,
        modifiers,
        modifiersStyles
    }

    const colors = ["#2D92A8", "#F16667"];

    bookings.forEach(booking => {
        if (!(booking.user_guid in users)) {
            users[booking.user_guid] = [];
            const color_index = (myGuid === booking.user_guid) ? "0" : "1";
            modifiersStyles[booking.user_guid] = {
                color: "#fffdee",
                backgroundColor: colors[color_index]
            };
        }

        const from = convertDateToUTC(new Date(booking.start_time))
        const to = convertDateToUTC(new Date(booking.end_time))

        if (hasEmptyIntervals(booking_stats, booking.start_time)) {
            modifiers["not_full"].push(from);
        }
        let end_booking_correction = null;
        if (booking.created_at > OLD_BOOKINGS_END_TIME) {  // after OLD_BOOKINGS_END_TIME this check line should be deleted
            const end_time = moment(to);
            if (end_time.hour() === 0 && end_time.minute() === 0) {  //this check is necessary because calendar will color next day if previous day ends at midnight 
                end_booking_correction = moment(to).subtract(1, 'day').toDate();
            }
        }

        if (hasEmptyIntervals(booking_stats, booking.end_time)) {
            if (!end_booking_correction) {
                modifiers["not_full"].push(to);
            }
        }

        users[booking.user_guid].push({
            from: from,
            to: end_booking_correction ? end_booking_correction : to
        });
    })

    return {
        users,
        modifiers,
        modifiersStyles,
        booking_stats
    }
};

const hasEmptyIntervals = (booking_stats, date) => {
    if (!booking_stats) return false;
    const day = moment.utc(date).format("YYYY-MM-DD");
    if (!booking_stats[day]) return false;

    if (booking_stats[day].is_full_day) {
        return false;
    } else {
        return true;
    }
}